import React, { useState } from 'react';
import ContactContext from '../contexts/contact-context';
import CookieConsent from './cookie-consent';

const Layout = ({ children }) => {
  const dialogState = useState(null);

  return (
    <ContactContext.Provider value={dialogState}>
      {children}
      <CookieConsent />
    </ContactContext.Provider>
  );
};

export default Layout;
